module.exports = __webpack_public_path__ + "assets/img/youtube.b12b7054.svg";